/* Export components */

export * from './components/clear-to-apply/clear-to-apply.component';
export * from './components/payment-details/payment-details.component';
export * from './components/your-personal-details/your-personal-details.component';
export * from './components/beneficiary-details/beneficiary-details.component';
export * from './components/annuitant-health-records/health-records.component';
export * from './components/dependant-health-records/dependant-health-records.component';
export * from './components/your-dependant-details/your-dependant-details.component';
export * from './components/submit-application/submit-application.component';
export * from './components/product-application/your-product-application/your-product-application.component';
export * from './components/product-application/application-summary/application-summary.component';
export * from './components/your-lump-sum-allowances/your-lump-sum-allowances.component';

/* Export config */
export * from './config/user-data.config';

/* Export module */
export * from './containers/after-apply.module';
